<app-layout>
<div class="row">
  <div class="col-lg-6 col-md-12 offset-lg-3 mt-3 mr-3">
    <div class="card">
      <div class="card-status-top bg-success"></div>
      <div class="card-body">
        <h3 class="card-title">{{talepNo}} nolu talebiniz başarıyla oluşturuldu.</h3>
        <div class="text-blue clickable" (click)="showTalepler()">Talepler Sayfasına Git</div>
        <br>
        <div class="text-green clickable" (click)="newTalep()">Yeni talep oluştur</div>
      </div>
    </div>
  </div>
</div>
</app-layout>
